import './noInstallment.css';
import PaymentBarIcon from '../../../assets/svg/Payment_bar.svg';
import TransactionIcon from '../../../assets/svg/Transactions.svg';

import {Box, Card, CardContent, Typography} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';

const NoInstallment = (props) => {
  const {t} = useTranslation();
  return (
    <div id="accountSummaryBox">
      <Box>
        <Card className="noInstallmentCustomCard">
          <CardContent className="noInstallmentCardContentCustom">
            <div className="noInstallmentIcons">
              {props.icon === 'nextInstallment' ? (
                <img src={TransactionIcon} alt="Transaction" />
              ) : (
                <img src={PaymentBarIcon} alt="Payment Bar" />
              )}
            </div>

            <div className="noInstallment">
              <Typography className="noInstallmentTitle">
                {t(props.title)}
              </Typography>
              <Typography className="noInstallmentSubTitle">
                {t(props.subTitle)}
              </Typography>
            </div>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};
export default NoInstallment;
